import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withFontClassName from '../../hoc/with-font-class-name';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import styles from './empty-states.scss';

const EmptyStates = ({
  title,
  content,
  className,
  children,
  titleFontClassName,
  contentFontClassName,
  borderWidth,
}) => {
  const containerClassName = classNames(
    styles.container,
    className,
    contentFontClassName,
    'forum-card-background-color',
    'forum-text-color',
    'forum-card-border-color'
  );
  return (
    <div className={containerClassName} style={{ borderWidth }}>
      <div className={titleFontClassName}>
        <div className={styles.header} data-hook="empty-states__header">
          {title}
        </div>
      </div>
      <div className={styles.content} data-hook="empty-states__content">
        {content}
      </div>
      {children &&
        <div className={styles.controls} data-hook="empty-states__sign-up">
          {children}
        </div>}
    </div>
  );
};

EmptyStates.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
};

export default withFontClassName(withCardBorderWidth(EmptyStates));



// WEBPACK FOOTER //
// ./app/components/empty-states/empty-states.js